import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_generation } from '@/hooks/store/use_slices';
import { REMOTE__user_task_load_generations_by_user_task_id } from '@/state/generation/user_task/entity/REMOTE__user_task_load_generations_by_user_task_id';

export function WATCHER__user_task_load_generations() {
  const dispatch = use_dispatch();
  const { user_task_current, user_task_load_generations_in_progress } = use_slice_generation(['user_task_current', 'user_task_load_generations_in_progress']);

  /*
   * EFFECTS
   */

  use_effect(() => {
    if (user_task_current.is_stub()) return;
    if (user_task_current.are_generations_loaded) return;
    if (user_task_load_generations_in_progress.has(user_task_current._id)) return;

    void dispatch(REMOTE__user_task_load_generations_by_user_task_id(user_task_current._id));
  }, [user_task_current]);

  return <></>;
}
